import { useQuery } from '@tanstack/react-query';
import { api } from './client.js';
import type { Statement, StatementMonths } from '@arcnet/contracts';

export const statementKeys = {
  months: (tenantId: string) => ['statements', tenantId] as const,
  one: (tenantId: string, month: string) => ['statements', tenantId, month] as const,
};

/** The months an account has a statement for, the latest first. */
export const useStatementMonths = (tenantId: string | null) =>
  useQuery({
    queryKey: statementKeys.months(tenantId ?? ''),
    queryFn: () => api.get<StatementMonths>(`/v1/tenants/${tenantId}/billing/statements`),
    enabled: !!tenantId,
  });

export const useStatement = (tenantId: string | null, month: string | null) =>
  useQuery({
    queryKey: statementKeys.one(tenantId ?? '', month ?? ''),
    queryFn: () => api.get<Statement>(`/v1/tenants/${tenantId}/billing/statements/${month}`),
    enabled: !!tenantId && !!month,
    retry: false, // a month with no statement is a 404, and a real answer
  });
